var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpenLayerPopup)?_c('div',{staticClass:"full-layer"},[_c('Adult',{on:{"enter-fn":_vm.onClickVerification,"exit-fn":_vm.onClickRouterBack}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }